import { ReactComponent as HeartIcon } from '../assets/icons/mdi_heart.svg';
import { ReactComponent as DoctorIcon } from '../assets/icons/maki_doctor.svg';
import { ReactComponent as SearchRoundedIcon } from '../assets/icons/search_rounded.svg';
import { ReactComponent as PulseIcon } from '../assets/icons/fluent_pulse.svg';

export const BOOLEAN_CONDITION_LABEL_NOT_SET = 'Not set';
export const BOOLEAN_CONDITION_LABEL_REQUIRE_TRUE = 'Require True';
export const BOOLEAN_CONDITION_LABEL_REQUIRE_FALSE = 'Require False';

export const CUSTOM_ICON_REGISTRY: Record<string, any> = {
  Heart: HeartIcon,
  Doctor: DoctorIcon,
  SearchRounded: SearchRoundedIcon,
  Pulse: PulseIcon,
};
